// Author YuJiaBei
// Date 2022-01-06 15:49:12

import * as model from "@/model/em/inspection/InspectionScheduleDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionScheduleDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
    })
    .buildStore()
